import React from "react";

export default class Checkbox extends React.Component {
	render() {
		return (
			<input className="checkbox" type="checkbox" name={this.props.name} checked={this.props.checked} onChange={this.props.onChange} />
		);
	}
}
